import TabPage from "./../../factories/tab-page";
import "./../../bindings/bao-searcher";
import "./../../bindings/bao-date-time-box";
import "./../../bindings/bao-date-time-picker";
import * as $ from "jquery";
import * as ko from "knockout";
import Bao from "./../../services/bao-service";
import BaoRouter from "../../services/bao-router";
import BaoDialog from "./../../factories/bao-dialog";
import * as moment from "moment";

class ShiftStaffingModel {
    Bao = Bao;
    TabPage: TabPage;
    ShiftStaffingCollection = ko.observableArray([]);
    StartDate = ko.observable('');
    EndDate = ko.observable('');
    ReportLoaded = ko.observable(false);
    Parent;
    ShiftbookId = ko.observable('');
    ShiftbookName = ko.observable('');
    IsMetadataUpdating = false;
    IsReportResultEmpty = ko.pureComputed(() => {
        return Boolean(this.ReportLoaded() && typeof this.ShiftStaffingCollection() !== "undefined" && this.ShiftStaffingCollection().length === 0);
    });
    /**
     * Gets the BaoDateTimeBox to select the filter-startdate.
     */
    public DateTimeBoxReportStartDate: Bindings.baoDateTimeBox = {
        mode: 'date',
        culture: Bao.Session.Language.Symbol,
        value: this.StartDate
    };
    /**
     * Gets the BaoDateTimeBox to select the filter-enddate.
     */
    public DateTimeBoxReportEndDate: Bindings.baoDateTimeBox = {
        mode: 'date',
        culture: Bao.Session.Language.Symbol,
        value: this.EndDate
    };
    /**
     * Gets the BaoDateTimePicker-instance.
     */
    public DateTimePicker: Bindings.baoDateTimePicker = {
        mode: 'date'
    };

    constructor(parent: any) {
        this.Parent = parent;
        this.TabPage = parent.TabPage;
    }
    init() {
        return this.GetMetadata();
    }
    loaded = () => {
        this.StartDate["Formatted"] = ko.pureComputed(() => {
            if (this.StartDate()) {
                return moment(this.StartDate(), Bao.Utils.DateTimeFormat).format(Bao.Utils.DateDisplayFormat);
            }
            else {
                return '';
            }
        });
        this.EndDate["Formatted"] = ko.pureComputed(() => {
            if (this.EndDate()) {
                return moment(this.EndDate(), Bao.Utils.DateTimeFormat).format(Bao.Utils.DateDisplayFormat);
            }
            else {
                return '';
            }
        });

        this.StartDate.subscribe((value) => {
            if (!this.IsMetadataUpdating) {
                this.GetMetadata();
            }
        });

        this.TabPage.IsLoading(false);
    }
    /** check if the manditory form fields are filled
     */
    IsComplete() {
        return Boolean(!Bao.Utils.String.IsNullOrEmpty(this.StartDate()) && this.ShiftbookName());
    };

    /**
    * Starts the download of the Report and applies all selected filters.
    */
    public DownloadReport(): void {
        if (!this.IsComplete()) {
            new BaoDialog(Bao.Session.ApplicationName, Bao.Session.GetMessage("msgFillMandatorFields"), "info");
            return;
        }

        this.TabPage.IsLoading(true);
        Bao.post('ReportCenter/GetDownloadShiftStaffingReport', JSON.stringify({
            startDate: this.StartDate(),
            shiftbookId: this.ShiftbookId()
        })).then(result => {
            if (result.Result == true) {
                BaoRouter.setHash("document/" + result.Message);
            }
        }).always(_ => {
            this.TabPage.IsLoading(false);
        });
    }

    private GetMetadata() {
        this.IsMetadataUpdating = true;
        this.TabPage.IsLoading(true);
        return Bao.post('ReportCenter/GetShiftStaffingReportMetadata', JSON.stringify({
            startDate: this.StartDate()
        })).then(result => {
            this.StartDate(result.Result.StartDate);
            this.EndDate(result.Result.EndDate);

        }).always(_ => {
            this.TabPage.IsLoading(false);
            this.IsMetadataUpdating = false;
        });
    }

}
export default ShiftStaffingModel;